// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gallery-menu {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 10px;
  border-radius: 10px;
  text-align: center;
  align-items: center;
  position: relative;
  width: 100%;
  margin-top: 10px;
  justify-content: center;
}

.gallery-item-cover {
  position: relative;
  width: 95vw;
  background-color: var(--orwi-menu-product-cover);
  box-shadow: var(--orwi-shadow);
  opacity: 1;
  margin-bottom: 20px;
  border-radius: var(--orwi-radius);
}

@media screen and (min-width: 768px) {
  .gallery-item-cover {
    width: 45vw;
    margin: 15px;
  }
  .gallery-picture {
    width: 100%;
    min-height: 250px;
  }
}
.gallery-picture {
  width: 100%;
}

.gallery-product-image {
  width: 100%;
  border-radius: 10px 10px 0px 0px;
  min-height: 250px;
}

.gallery-text-cover {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: left;
}

.gallery-price {
  font-size: 14px;
  font-weight: bold;
  color: var(--orwi-menu-product-price);
  margin-right: 10px;
}

.gallery-product-image {
  width: 100%;
  border-radius: 10px 10px 0px 0px;
  min-height: 250px;
}

.gallery-name {
  font-size: 14px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gallery-description {
  font-size: 12px;
  text-align: left;
  margin-top: 5px;
}

.product-image {
  min-height: 200px;
}

.search-results {
  height: 20rem;
  overflow: scroll;
}

.sold-out {
  position: absolute;
  /* top: calc(50% - 25px); */
  z-index: 50;
  color: var(--orwi-menu-product-price);
  font-size: 30px;
  background-color: rgba(0, 0, 0, 0.5215686275);
  height: 60px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: var(--orwi-radius);
  color: white;
  bottom: 0px;
}

*,
*:before,
*:after {
  box-sizing: border-box;
}

.ribbon {
  background: #d11508;
  display: inline-block;
  color: #f4f4f4;
  padding: 0.5em 0.7em;
  font-weight: 900;
  letter-spacing: 0.2em;
  position: relative;
  font-size: 1em;
  transform-style: preserve-3d;
  transform: rotate(350deg) skew(-20deg, 10deg);
}
.ribbon:before, .ribbon:after {
  content: "";
  width: 0;
  height: 2em;
  display: block;
  background: #d11508;
  position: absolute;
  border-style: solid;
  border-width: 0.5em;
  z-index: -1;
  transform: translateZ(-1em);
}
.ribbon:before {
  left: -0.5em;
  top: 0.5em;
  border-color: #870e05 #560903 #870e05 #870e05;
}
.ribbon:after {
  right: -0.5em;
  top: -0.5em;
  border-color: #870e05 #870e05 #870e05 #560903;
}

.high-light {
  color: red;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu/product-gallery/product-gallery.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,gDAAA;EACA,8BAAA;EACA,UAAA;EACA,mBAAA;EACA,iCAAA;AACF;;AAGA;EAEE;IAEE,WAAA;IACA,YAAA;EAFF;EAMA;IACE,WAAA;IACA,iBAAA;EAJF;AACF;AASA;EACE,WAAA;AAPF;;AAUA;EACE,WAAA;EACA,gCAAA;EACA,iBAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,kBAAA;AAPF;;AAUA;EACE,WAAA;EACA,gCAAA;EACA,iBAAA;AAPF;;AAUA;EACE,eAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAPF;;AAUA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AAPF;;AAUA;EACE,iBAAA;AAPF;;AAUA;EACE,aAAA;EACA,gBAAA;AAPF;;AAUA;EACE,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,qCAAA;EACA,eAAA;EACA,6CAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,iCAAA;EACA,YAAA;EACA,WAAA;AAPF;;AAiBA;;;EAGE,sBAAA;AAdF;;AAiBA;EACE,mBAbO;EAcP,qBAAA;EACA,cAhBG;EAiBH,oBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAjBS;EAmBT,4BAAA;EACA,6CAAA;AAfF;AAiBE;EAEE,WAAA;EACA,QAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAhCS;EAiCT,WAAA;EACA,2BAAA;AAhBJ;AAmBE;EACE,YAAA;EACA,UAvCS;EAwCT,6CAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,WAAA;EACA,6CAAA;AAlBJ;;AAuBA;EACE,UAAA;AApBF","sourcesContent":[".gallery-menu {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  border-radius: 10px;\n  text-align: center;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  margin-top: 10px;\n  justify-content: center;\n}\n\n.gallery-item-cover {\n  position: relative;\n  width: 95vw;\n  background-color: var(--orwi-menu-product-cover);\n  box-shadow: var(--orwi-shadow);\n  opacity: 1;\n  margin-bottom: 20px;\n  border-radius: var(--orwi-radius);\n}\n\n\n@media screen and (min-width: 768px) {\n \n  .gallery-item-cover {\n   \n    width: 45vw;\n    margin: 15px;\n    \n  }\n\n  .gallery-picture {\n    width: 100%;\n    min-height: 250px;\n  }\n  \n}\n\n\n.gallery-picture {\n  width: 100%;\n}\n\n.gallery-product-image {\n  width: 100%;\n  border-radius: 10px 10px 0px 0px;\n  min-height: 250px;\n}\n\n.gallery-text-cover {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding-left: 5px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  text-align: left;\n}\n\n.gallery-price {\n  font-size: 14px;\n  font-weight: bold;\n  color: var(--orwi-menu-product-price);\n  margin-right: 10px;\n}\n\n.gallery-product-image {\n  width: 100%;\n  border-radius: 10px 10px 0px 0px;\n  min-height: 250px;\n}\n\n.gallery-name {\n  font-size: 14px;\n  font-weight: bold;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.gallery-description {\n  font-size: 12px;\n  text-align: left;\n  margin-top: 5px;\n}\n\n.product-image {\n  min-height: 200px;\n}\n\n.search-results {\n  height: 20rem;\n  overflow: scroll;\n}\n\n.sold-out {\n  position: absolute;\n  /* top: calc(50% - 25px); */\n  z-index: 50;\n  color: var(--orwi-menu-product-price);\n  font-size: 30px;\n  background-color: #00000085;\n  height: 60px;\n  display: flex;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  border-radius: var(--orwi-radius);\n  color: white;\n  bottom: 0px;\n}\n\n$bg: #f4f4f4;\n$ribbon: #d11508;\n$tail: darken($ribbon, 15%);\n$ribbonSize: 0.5em;\n$fontSize: 1em;\n$font: \"Roboto\", sans-serif;\n\n*,\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n.ribbon {\n  background: $ribbon;\n  display: inline-block;\n  color: $bg;\n  padding: $ribbonSize 0.7em;\n  font-weight: 900;\n  letter-spacing: 0.2em;\n  position: relative;\n  font-size: $fontSize;\n  //text-transform: uppercase;\n  transform-style: preserve-3d;\n  transform: rotate(350deg) skew(-20deg, 10deg);\n\n  &:before,\n  &:after {\n    content: \"\";\n    width: 0;\n    height: 2em;\n    display: block;\n    background: #d11508;\n    position: absolute;\n    border-style: solid;\n    border-width: $ribbonSize;\n    z-index: -1; // only necessary for flat (transform-style)\n    transform: translateZ(-1em); // orders the ribbon tails\n  }\n\n  &:before {\n    left: $ribbonSize * -1;\n    top: $ribbonSize;\n    border-color: $tail darken($tail, 10%) $tail $tail;\n  }\n\n  &:after {\n    right: $ribbonSize * -1;\n    top: $ribbonSize * -1;\n    border-color: $tail $tail $tail darken($tail, 10%);\n  }\n}\n\n\n.high-light {\n  color:red;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
